import { Area, AreaChart, ResponsiveContainer, Tooltip, YAxis } from 'recharts';

import { money } from '@/lib/utils';

/** Last 7 days of revenue. Server always returns exactly 7 points. */
export function RevenueSparkline({ data }: { data: number[] }) {
  const points = data.map((value, index) => ({ index, value }));
  const allZero = data.every((v) => v === 0);

  if (allZero) {
    return (
      <div className="flex h-24 items-center justify-center text-sm text-muted-foreground">
        No sales in the last 7 days yet.
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={96}>
      <AreaChart data={points} margin={{ top: 4, right: 4, bottom: 0, left: 4 }}>
        <defs>
          <linearGradient id="sparklineFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FF6B4D" stopOpacity={0.4} />
            <stop offset="100%" stopColor="#FF6B4D" stopOpacity={0} />
          </linearGradient>
        </defs>
        <YAxis hide domain={[0, 'dataMax']} />
        <Tooltip
          cursor={{ stroke: '#FF6B4D', strokeWidth: 1, strokeDasharray: '4 4' }}
          content={({ active, payload }) => {
            if (!active || !payload?.[0]) return null;
            return (
              <div className="rounded-md border border-border bg-popover px-2.5 py-1.5 text-xs shadow-lg">
                {money(payload[0].value as number)}
              </div>
            );
          }}
        />
        <Area
          type="monotone"
          dataKey="value"
          stroke="#FF6B4D"
          strokeWidth={2}
          fill="url(#sparklineFill)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}